<template>
  <v-row>
    <v-progress-linear v-if="isLoading" :indeterminate="true"></v-progress-linear>
    <v-snackbar
      v-model="showSnackbar"
      color="error"
    >
      {{ text }}
      <v-btn
        text
        @click.native="showSnackbar = false">{{ $t('common.buttons.close') }}</v-btn>
    </v-snackbar>
    <v-col cols="6">
      <v-card>
        <v-card-title primary-title>
          Suidlanders
        </v-card-title>
        <list-clients :list="suidlandersList" :icon="mdiChevronRight" @move="moveToDons" />
      </v-card>
    </v-col>
    <v-col cols="6">
      <v-card>
        <v-card-title primary-title>
          DONS
        </v-card-title>
        <list-clients :list="donsList" :icon="mdiChevronLeft" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import ListClients from '../components/ListClients.vue';

export default {
  name: 'AdminClientLists',
  module: 'Membership',
  components: {
    ListClients,
  },
  mixins: [loading],
  data() {
    return {
      mdiChevronLeft,
      mdiChevronRight,
      suidlandersList: [],
      donsList: [],
      showSnackbar: false,
      text: '',
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async moveToDons(item) {
      this.isLoading = true;
      try {
        const result = await this.$http.post('/softy/comp/api/clientLists/dons/move', {
          sourceClientId: item.clientId,
        });
        this.$log.info(result);
        this.$root.$emit('toast:notify', this.$t('common.phrases.savedSuccessfully'));
      } catch (error) {
        // eslint-disable-next-line no-alert
        const { response } = error;
        const { request, ...errorObject } = response; // take everything but 'request'
        this.text = errorObject.data.exceptionMessage;
        this.showSnackbar = true;
      }
      this.refresh();
      this.isLoading = false;
    },
    async refresh() {
      this.isLoading = true;
      await Promise.all([
        (async () => {
          const result = await this.$http.get('/softy/comp/api/clientLists/suidlanders');
          this.suidlandersList = result.data;
        })(),
        (async () => {
          const result = await this.$http.get('/softy/comp/api/clientLists/dons');
          this.donsList = result.data;
        })(),
      ]);
      this.isLoading = false;
    },
  },
};
</script>
